import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { Title } from '@angular/platform-browser';
import { StorageService } from './storage.service';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private islogedIn$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isNavigationCollapse$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private titleService: Title,
    private authService: MsalService,
    private _storageService: StorageService,
    private _usersService: UsersService,
  ) { }

  setPageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  isLoginSet(val: boolean) {
    this.islogedIn$.next(val);
  }
  isLoginGet() {
    return this.islogedIn$.asObservable();
  }
  isLoginGetByValue() {
    return this.islogedIn$.getValue();
  }

  isNavigationCollapseSet(val: boolean) {
    this.isNavigationCollapse$.next(val);
  }
  isNavigationCollapseGet() {
    return this.isNavigationCollapse$.asObservable();
  }
  isNavigationCollapseByValue() {
    return this.isNavigationCollapse$.getValue();
  }

  logout() {
    this.authService.logoutRedirect();
  }

  getUserRole() {
    const userDetails = this._storageService.getDataFromStorage("userDetails");
    if(userDetails){
      const user = JSON.parse(userDetails)
      return user.role;
    }
    else{
      return 0;
    }
  }

  getUserInfo(): Promise<any>{
    return new Promise((resolve, reject) => {
      let user = {};
      this._usersService.getUsers()
        .subscribe({
          next: (res) => {
            if (res.data.getUserDetails.success) {
              user = res.data.getUserDetails.user;
              this._storageService.putDataInStorage("userDetails", JSON.stringify(user));
              resolve(user);
            }
            else reject(res.data.getUserDetails.success)
          }
        })
    });    
  }
}
